// src/locales/en/warehouses.js
export const warehouses = {
    
    createNewWarehouse: "නව ගබඩාවක් සාදන්න",
    setupYourWarehouse: "ඔබේ ගබඩාවේ විස්තර සහ තොරතුරු සකස් කරන්න",
    backToWarehouses: "ගබඩා වෙත ආපසු",
    
    basicInformation: "මූලික තොරතුරු",
    basicInformationDesc: "ඔබේ ගබඩාව පිළිබඳ මූලික විස්තර සපයන්න",
    warehouseName: "ගබඩාවේ නම",
    warehouseNamePlaceholder: "ගබඩාවේ නම ඇතුළත් කරන්න (උදා: ප්‍රධාන ගබඩාව, ගබඩා ඒකකය A)",
    addressPlaceholder: "සම්පූර්ණ ගබඩා ලිපිනය ඇතුළත් කරන්න...",
    addressHint: "වඩා හොඳ හඳුනාගැනීම සඳහා වීථි ලිපිනය, නගරය සහ තැපැල් කේතය ඇතුළත් කරන්න",
    phonePlaceholder: "සම්බන්ධතා අංකය ඇතුළත් කරන්න",
    phoneHint: "ගබඩා මෙහෙයුම් සහ සම්බන්ධීකරණය සඳහා සම්බන්ධතා අංකය",
    phone: "දුරකථන අංකය",
    address: "ලිපිනය",
    
    nameRequired: "ගබඩාවේ නම අවශ්‍යය",
    nameMinLength: "ගබඩාවේ නම අවම වශයෙන් අක්ෂර 2ක් විය යුතුය",
    invalidPhone: "කරුණාකර වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න",
    
    createWarehouse: "ගබඩාව සාදන්න",
    
    warehouseCreatedSuccess: "'{{warehouseName}}' ගබඩාව සාර්ථකව සාදන ලදී!",
    failedToCreate: "ගබඩාව සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",

    manageYourWarehouses: "ඔබේ සියලුම ගබඩා සහ ඒවායේ තොරතුරු කළමනාකරණය කරන්න",
    loadingWarehouses: "ගබඩා පූරණය වෙමින්...",
    loadingWarehousesDesc: "අපි ඔබේ ගබඩා ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    searchWarehouses: "නම, ලිපිනය, හෝ දුරකථනය අනුව ගබඩා සොයන්න...",
    filteredResults: "ගබඩා {{total}} න් {{count}} ක්",
    totalWarehouses: "ගබඩා {{count}} ක්",
    allWarehouses: "සියලුම ගබඩා",
    noSearchResults: "ගබඩා හමු නොවිණි",
    noSearchResultsDesc: "ඔබේ සෙවුම් පද වෙනස් කිරීමට උත්සාහ කරන්න හෝ සියලු ගබඩා බැලීමට ෆිල්ටර ඉවත් කරන්න.",
    noWarehouses: "තවම ගබඩා නැත",
    noWarehousesDesc: "ඔබේ ඉන්වෙන්ටරි ස්ථාන කළමනාකරණය කිරීම ආරම්භ කිරීමට ඔබේ පළමු ගබඩාව සාදන්න.",
    createFirstWarehouse: "පළමු ගබඩාව සාදන්න",
    
    contact: "සම්බන්ධතාව",
    
    noContact: "සම්බන්ධතා තොරතුරු නැත",
    
    confirmDelete: "ඔබට '{{warehouseName}}' ගබඩාව මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    warehouseDeletedSuccess: "'{{warehouseName}}' ගබඩාව සාර්ථකව මකා දමන ලදී.",
    failedToDelete: "ගබඩාව මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",

    addWarehouse: "ගබඩාව එකතු කරන්න",
    editWarehouse: "ගබඩාව සංස්කරණය කරන්න", 
    updateWarehouse: "ගබඩාව යාවත්කාලීන කරන්න",
    warehouseUpdatedSuccess: "'{{warehouseName}}' ගබඩාව සාර්ථකව යාවත්කාලීන කරන ලදී!",
    failedToUpdate: "ගබඩාව යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToLoadWarehouse: "ගබඩා විස්තර පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
}